class Testimonial extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.slides = [];
  }

  connectedCallback() {
    // Obtener referencias a los elementos
    this.slides = this.querySelectorAll('.m-testimonial__items');
    this.prevBtn = this.querySelector('.m-testimonial__nav-button.--prev');
    this.nextBtn = this.querySelector('.m-testimonial__nav-button.--next');
    
    // Referencia a la barra de progreso
    this.progressIndicator = this.querySelector('.m-testimonial__progress-indicator');
    
    // Inicializar el carrusel
    this.initializeCarousel();
    
    // Configurar event listeners
    this.setupEventListeners();
  }

  initializeCarousel() {
    // Ocultar todos los slides excepto el primero
    this.slides.forEach((slide, index) => {
      if (index === 0) {
        slide.classList.add('--active');
      } else {
        slide.classList.remove('--active');
      }
    });
    
    // Inicializar la barra de progreso
    this.updateProgressBar(0);
  }

  setupEventListeners() {
    // Event listeners para botones de navegación
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.showSlide(this.currentIndex - 1));
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.showSlide(this.currentIndex + 1));
    }
  }

  showSlide(index) {
    // Manejar índices circulares
    if (index < 0) index = this.slides.length - 1;
    if (index >= this.slides.length) index = 0;
    
    // Ocultar todos los slides
    this.slides.forEach(slide => slide.classList.remove('--active'));
    
    // Mostrar el slide seleccionado
    this.slides[index].classList.add('--active');
    
    // Actualizar el índice actual
    this.currentIndex = index;
    
    // Actualizar la barra de progreso
    this.updateProgressBar(index);
  }
  
  updateProgressBar(index) {
    // Actualizar el ancho de la barra de progreso
    if (this.progressIndicator) {
      const progressPercentage = ((index + 1) / this.slides.length) * 100;
      this.progressIndicator.style.width = `${progressPercentage}%`;
    }
  }
}

// Registrar el elemento personalizado
customElements.define('m-testimonial', Testimonial);